import React from "react";
import { DayOfWeek, LocalTime, LocalDate } from "@js-joda/core";
import styled from "@emotion/styled";
import Flex from "../Generic/Flex";
import { formatDate, formatDayOfWeek, formatTime } from "../../utils/dateUtils";

export type FlexibleVisitRequestDetails = {
  type: "Flexible";
  days: {
    day: DayOfWeek;
    startTime: LocalTime;
    endTime: LocalTime;
  }[];
  startDate: LocalDate;
  endDate: LocalDate;
  visitRate: number | null;
  address: string;
};

interface Props {
  requestDetails: FlexibleVisitRequestDetails;
}

const MedflytRequestFlexibleVisitDetails = (props: Props) => {
  return (
    <Flex direction="column" gap={8}>
      <div>
        {`${formatDate(props.requestDetails.startDate)} - ${formatDate(
          props.requestDetails.endDate
        )}`}
      </div>
      {props.requestDetails.days
        .sort((shift1, shift2) => shift1.day.ordinal() - shift2.day.ordinal())
        .map((day) => {
          return (
            <RequestedShiftRow key={`shift-${day.day.ordinal()}`}>
              <div>{formatDayOfWeek(day.day)}</div>
              <RequestedTimes>
                <div>{`${formatTime(day.startTime)} `}</div>
                <div>{`-`}</div>
                <div>{`${formatTime(day.endTime)}`}</div>
              </RequestedTimes>
            </RequestedShiftRow>
          );
        })}
    </Flex>
  );
};

export default MedflytRequestFlexibleVisitDetails;

const RequestedShiftRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
`;

const RequestedTimes = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  justify-content: space-between;
`;
